import { useEffect, useState } from "react";
import Popup from "./Popup/Popup";
import ExportCsvBtn from "./AppSpecificConpnents/ExportCsvBtn";
import { BASE_URL } from "../config";
const ImportCsvSuccessPopup = ({importedInfo, setNullInportData}) => {
  const [showPopup, setShowPopup] = useState(true);
  const { inserted, updated, noChanges, failed, duplicates } = importedInfo

  const resolvedMissingHeaders =
    importedInfo?.missingHeaders ||
    importedInfo?.missing_headers ||
    importedInfo?.data?.missingHeaders ||
    importedInfo?.data?.missing_headers ||
    importedInfo?.response?.missingHeaders ||
    importedInfo?.response?.missing_headers ||
    importedInfo?.response?.data?.missingHeaders ||
    importedInfo?.response?.data?.missing_headers ||
    [];
  const missingHeadersCount = Array.isArray(resolvedMissingHeaders)
    ? resolvedMissingHeaders.length
    : 0;
  const parsedFailedCount = Number(failed);
  const resolvedFailedCount = Number.isFinite(parsedFailedCount)
    ? parsedFailedCount
    : missingHeadersCount;
  
  useEffect(()=>{
    setShowPopup(true)
  },[importedInfo])

  const downloadCsv = () =>{
  const link = document.createElement("a");
  link.href = BASE_URL.replace("/api/", "") + importedInfo.csv;
  link.setAttribute("download", importedInfo.csv);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  }

  const printWithS = (count) =>{
    let Record = "Row"
    if(count > 1){
      Record += "s"
    }
    return Record
  }
  return <>{showPopup && <Popup 
    title="Import Summary" 
    small={true} 
    closeModal={()=>{
      setNullInportData(null)
      setShowPopup(false)
    }}
    shouldScroll={false}
  >


    <div style={{padding:"10px"}}>
      <div style={{fontSize:"13px"}}>
        <>
          <p><strong>{inserted || 0}</strong> {printWithS(inserted || 0)} Created</p>
          <p><strong>{updated || 0}</strong> {printWithS(updated || 0)} Updated</p>
          <p><strong>{noChanges || 0}</strong> {printWithS(noChanges || 0)} Have No Changes</p>
          <p><strong>{resolvedFailedCount}</strong> Invalid Data - {printWithS(resolvedFailedCount)} Could Not be Imported or Updated</p>  
          <p><strong>{duplicates || 0}</strong> Duplicate {printWithS(duplicates || 0)} Found - {printWithS(duplicates || 0)} Could Not be Imported or Updated</p>  
          <hr style={{border: "0.1px solid #eeeeee"}}/>
        </>
      </div>
      {importedInfo?.csv && (
        <ExportCsvBtn handleExportCSV={downloadCsv}   buttonLabel="Download CSV"/>
      )}
    </div>
  </Popup>}</>;
};

export default ImportCsvSuccessPopup;
